import {action, observable} from 'mobx'; 
import urlParse from 'url-parse';

export class VForgottenPassword {
  constructor(flasher, api, navigation, passwordRecoveryEmailForm, passwordRecoveryPasswordForm) {
    this.flasher = flasher;
    this.api = api;
    this.navigation = navigation;
    this.passwordRecoveryEmailForm = passwordRecoveryEmailForm;
    this.passwordRecoveryPasswordForm = passwordRecoveryPasswordForm;
  }

  @observable userName = '';
  @observable email = '';

  @action.bound async sendEmail() {
    try {
      this.flasher.setOther('Loading.');
      const {email} = this.passwordRecoveryEmailForm.computedRawValues;
      await this.api.invokeResetPassword({
        organizationId: this.orgId,
        email,
      })
      this.navigation.goPasswordRecovery2(email);
    }
    catch(e) {
      this.flasher.handleError(e);
    }
    finally {
      this.flasher.setOther(); 
    }
  }

  @action.bound async setPassword() {
    try {
      this.flasher.setOther('Loading.');
      const {password1, password2} = this.passwordRecoveryPasswordForm.computedRawValues;
      await this.api.resetPassword({
        newPassword: password1,
        confirmPassword: password2,
        token: this.token, 
        userName: this.userName,
      });
      this.navigation.goPasswordRecovery4();
    }
    catch(e) {
      this.flasher.handleError(e);
    }
    finally {
      this.flasher.setOther(); 
    }    
  }

  interpretLink(link) {
    const url = urlParse(link, true);
    if(url.hash === '#/reset-pwd') {
      this.navigation.goPasswordRecovery3({
        userName: url.query.userName,
        token: url.query.token,
      });
    }
  }

  async startOrUpdate({orgId, email, token, userName, code, step}) {
    this.orgId = orgId;
    this.email = email;
    this.token = token;
    this.userName = userName;
    this.code = code;

    if(step === '3') {
      this.orgId = (await this.api.getIdByReferenceCode({code})).Id;
      window.sessionStorage.setItem('orgId', this.orgId);
    }
  }

  stop() {

  }
}


// WEBPACK FOOTER //
// ./src/view/VForgottenPassword.js